import { render, staticRenderFns } from "./DeleteTransactions.vue?vue&type=template&id=042c2cc6&scoped=true"
import script from "./DeleteTransactions.vue?vue&type=script&lang=js"
export * from "./DeleteTransactions.vue?vue&type=script&lang=js"
import style0 from "./DeleteTransactions.vue?vue&type=style&index=0&id=042c2cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c2cc6",
  null
  
)

export default component.exports